"use client";

import { useQuery } from "@tanstack/react-query";
// 2.858: from the menu's own module, never `@/lib/api/scans`: the shell imports
// this hook (2.854), so its imports ship in the entry chunk.
import { listScanProfiles } from "@/lib/api/scan-profiles";

/**
 * Keyed on nothing: S-166's menu is a PLATFORM property, identical in every
 * project and every organisation, so a project-scoped cache key would be a
 * claim the ruling contradicts.
 */
export function useScanProfiles(options: { enabled?: boolean } = {}) {
  return useQuery({ queryKey: ["scan-profiles"], queryFn: listScanProfiles, enabled: options.enabled ?? true });
}
